import { default as change_45passwordlnF89pKfG4Meta } from "/app/pages/account/change-password.vue?macro=true";
import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as change_45passwordX8ivx1vU2lMeta } from "/app/pages/auth/change-password.vue?macro=true";
import { default as confirm_45accountvbPahADDW0Meta } from "/app/pages/auth/confirm-account.vue?macro=true";
import { default as reset_45password5ABZjlJW61Meta } from "/app/pages/auth/reset-password.vue?macro=true";
import { default as signinFK2lTWFqnvMeta } from "/app/pages/auth/signin.vue?macro=true";
import { default as signupHJ1GDnyyMkMeta } from "/app/pages/auth/signup.vue?macro=true";
import { default as _91_id_93SzmYjArBjaMeta } from "/app/pages/blog/[_id].vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as privacyvSm3wr4bxjMeta } from "/app/pages/documents/privacy.vue?macro=true";
import { default as termsdb5PyA4gx0Meta } from "/app/pages/documents/terms.vue?macro=true";
import { default as ua8DX7n8W6lnMeta } from "/app/pages/documents/ua.vue?macro=true";
import { default as documentsAtnLAchromMeta } from "/app/pages/documents.vue?macro=true";
import { default as downloadsynMhguGMjYMeta } from "/app/pages/downloads.vue?macro=true";
import { default as _91id_93MRJgxkWB8iMeta } from "/app/pages/email/get/[id].vue?macro=true";
import { default as _91id_93VoQbvPFVxgMeta } from "/app/pages/email/verify/[id].vue?macro=true";
import { default as faqIMkmXQpKKaMeta } from "/app/pages/faq.vue?macro=true";
import { default as _91_id_93v3xpduioRhMeta } from "/app/pages/glossary/[_id].vue?macro=true";
import { default as index3NQXRv7QplMeta } from "/app/pages/glossary/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91_id_93zX6iU92mf7Meta } from "/app/pages/partners/[_id].vue?macro=true";
import { default as indexLG3Wtz8U6fMeta } from "/app/pages/partners/index.vue?macro=true";
import { default as successUvCmUCQewKMeta } from "/app/pages/payment/success.vue?macro=true";
import { default as pricesC8xY6SsZYuMeta } from "/app/pages/prices.vue?macro=true";
import { default as referalCBFjzhrveyMeta } from "/app/pages/referal.vue?macro=true";
import { default as _91_id_93eQWlvBpSj8Meta } from "/app/pages/tutorial/[_id].vue?macro=true";
import { default as index3Gq4tMcM7aMeta } from "/app/pages/tutorial/index.vue?macro=true";
export default [
  {
    name: "account-change-password___en___default",
    path: "/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___en",
    path: "/en/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___ua",
    path: "/ua/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___ru",
    path: "/ru/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___es",
    path: "/es/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___pt",
    path: "/pt/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-change-password___zh",
    path: "/zh/account/change-password",
    component: () => import("/app/pages/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account___en___default",
    path: "/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___ua",
    path: "/ua/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___ru",
    path: "/ru/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___es",
    path: "/es/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___pt",
    path: "/pt/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___zh",
    path: "/zh/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___en___default",
    path: "/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___en",
    path: "/en/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___ua",
    path: "/ua/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___ru",
    path: "/ru/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___es",
    path: "/es/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___pt",
    path: "/pt/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-change-password___zh",
    path: "/zh/auth/change-password",
    component: () => import("/app/pages/auth/change-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___en___default",
    path: "/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___en",
    path: "/en/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___ua",
    path: "/ua/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___ru",
    path: "/ru/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___es",
    path: "/es/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___pt",
    path: "/pt/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-confirm-account___zh",
    path: "/zh/auth/confirm-account",
    component: () => import("/app/pages/auth/confirm-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___en___default",
    path: "/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___ua",
    path: "/ua/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___ru",
    path: "/ru/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___es",
    path: "/es/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___pt",
    path: "/pt/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset-password___zh",
    path: "/zh/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___en___default",
    path: "/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___en",
    path: "/en/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___ua",
    path: "/ua/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___ru",
    path: "/ru/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___es",
    path: "/es/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___pt",
    path: "/pt/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signin___zh",
    path: "/zh/auth/signin",
    component: () => import("/app/pages/auth/signin.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___en___default",
    path: "/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___en",
    path: "/en/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___ua",
    path: "/ua/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___ru",
    path: "/ru/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___es",
    path: "/es/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___pt",
    path: "/pt/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "auth-signup___zh",
    path: "/zh/auth/signup",
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___en___default",
    path: "/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___en",
    path: "/en/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___ua",
    path: "/ua/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___ru",
    path: "/ru/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___es",
    path: "/es/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___pt",
    path: "/pt/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog-_id___zh",
    path: "/zh/blog/:_id()",
    component: () => import("/app/pages/blog/[_id].vue").then(m => m.default || m)
  },
  {
    name: "blog___en___default",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___ua",
    path: "/ua/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___es",
    path: "/es/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "documents___en___default",
    path: "/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___en___default",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___en___default",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___en___default",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___en",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___en",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___en",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___ua",
    path: "/ua/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___ua",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___ua",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___ua",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___ru",
    path: "/ru/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___ru",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___ru",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___ru",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___es",
    path: "/es/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___es",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___es",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___es",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___pt",
    path: "/pt/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___pt",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___pt",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___pt",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "documents___zh",
    path: "/zh/documents",
    component: () => import("/app/pages/documents.vue").then(m => m.default || m),
    children: [
  {
    name: "documents-privacy___zh",
    path: "privacy",
    component: () => import("/app/pages/documents/privacy.vue").then(m => m.default || m)
  },
  {
    name: "documents-terms___zh",
    path: "terms",
    component: () => import("/app/pages/documents/terms.vue").then(m => m.default || m)
  },
  {
    name: "documents-ua___zh",
    path: "ua",
    component: () => import("/app/pages/documents/ua.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "downloads___en___default",
    path: "/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___en",
    path: "/en/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___ua",
    path: "/ua/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___ru",
    path: "/ru/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___es",
    path: "/es/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___pt",
    path: "/pt/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "downloads___zh",
    path: "/zh/downloads",
    component: () => import("/app/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___en___default",
    path: "/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___en",
    path: "/en/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___ua",
    path: "/ua/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___ru",
    path: "/ru/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___es",
    path: "/es/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___pt",
    path: "/pt/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-get-id___zh",
    path: "/zh/email/get/:id()",
    meta: _91id_93MRJgxkWB8iMeta || {},
    component: () => import("/app/pages/email/get/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___en___default",
    path: "/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___en",
    path: "/en/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___ua",
    path: "/ua/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___ru",
    path: "/ru/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___es",
    path: "/es/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___pt",
    path: "/pt/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "email-verify-id___zh",
    path: "/zh/email/verify/:id()",
    meta: _91id_93VoQbvPFVxgMeta || {},
    component: () => import("/app/pages/email/verify/[id].vue").then(m => m.default || m)
  },
  {
    name: "faq___en___default",
    path: "/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___ua",
    path: "/ua/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/app/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___en___default",
    path: "/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___en",
    path: "/en/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___ua",
    path: "/ua/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___ru",
    path: "/ru/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___es",
    path: "/es/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___pt",
    path: "/pt/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary-_id___zh",
    path: "/zh/glossary/:_id()",
    component: () => import("/app/pages/glossary/[_id].vue").then(m => m.default || m)
  },
  {
    name: "glossary___en___default",
    path: "/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___en",
    path: "/en/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___ua",
    path: "/ua/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___ru",
    path: "/ru/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___es",
    path: "/es/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___pt",
    path: "/pt/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "glossary___zh",
    path: "/zh/glossary",
    component: () => import("/app/pages/glossary/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ua",
    path: "/ua",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___en___default",
    path: "/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___en",
    path: "/en/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___ua",
    path: "/ua/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___ru",
    path: "/ru/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___es",
    path: "/es/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___pt",
    path: "/pt/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners-_id___zh",
    path: "/zh/partners/:_id()",
    component: () => import("/app/pages/partners/[_id].vue").then(m => m.default || m)
  },
  {
    name: "partners___en___default",
    path: "/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___ua",
    path: "/ua/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___ru",
    path: "/ru/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___es",
    path: "/es/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___pt",
    path: "/pt/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners___zh",
    path: "/zh/partners",
    component: () => import("/app/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___en___default",
    path: "/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___en",
    path: "/en/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___ua",
    path: "/ua/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___ru",
    path: "/ru/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___es",
    path: "/es/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___pt",
    path: "/pt/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "payment-success___zh",
    path: "/zh/payment/success",
    meta: successUvCmUCQewKMeta || {},
    component: () => import("/app/pages/payment/success.vue").then(m => m.default || m)
  },
  {
    name: "prices___en___default",
    path: "/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___en",
    path: "/en/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___ua",
    path: "/ua/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___ru",
    path: "/ru/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___es",
    path: "/es/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___pt",
    path: "/pt/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "prices___zh",
    path: "/zh/prices",
    meta: pricesC8xY6SsZYuMeta || {},
    component: () => import("/app/pages/prices.vue").then(m => m.default || m)
  },
  {
    name: "referal___en___default",
    path: "/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___en",
    path: "/en/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___ua",
    path: "/ua/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___ru",
    path: "/ru/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___es",
    path: "/es/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___pt",
    path: "/pt/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "referal___zh",
    path: "/zh/referal",
    component: () => import("/app/pages/referal.vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___en___default",
    path: "/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___en",
    path: "/en/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___ua",
    path: "/ua/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___ru",
    path: "/ru/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___es",
    path: "/es/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___pt",
    path: "/pt/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial-_id___zh",
    path: "/zh/tutorial/:_id()",
    component: () => import("/app/pages/tutorial/[_id].vue").then(m => m.default || m)
  },
  {
    name: "tutorial___en___default",
    path: "/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___en",
    path: "/en/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___ua",
    path: "/ua/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___ru",
    path: "/ru/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___es",
    path: "/es/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___pt",
    path: "/pt/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  },
  {
    name: "tutorial___zh",
    path: "/zh/tutorial",
    component: () => import("/app/pages/tutorial/index.vue").then(m => m.default || m)
  }
]